export default "__VITE_ASSET__BsUkHFro__"